import { Meteor } from 'meteor/meteor';
import { dataUrlToFile, randomString } from '/imports/utils';
import { AndroidDevice } from '/imports/types';
import { ensureAndroidDevice } from '/imports/api/users';

const w = window as any;
export const AndroidClient = Meteor.isClient ? w.AndroidClient : null;

if (Meteor.isClient) {
  w.ensureAndroidDevice = async (device: AndroidDevice) => {
    try {
      await ensureAndroidDevice.call(device);
    }
    catch (error) {
      console.log(error);
    }
  };
}

/**
 * Triggers the native Android file chooser and forwards the picked file.
 * @param handler - Called with the chosen file once decoded.
 */
export const initiateAndroidUpload = (handler: (file: File) => void) => {
  const listener = `androidUpload${randomString()}`;
  w[listener] = (name: string, fileB64: string) => {
    delete w[listener];
    const file = dataUrlToFile(fileB64, name);
    handler(file);
  };
  AndroidClient.initiateFileChooser(listener);
};

/** Whether the app is running inside the Android webview. */
export const isAndroid = () => !!(window as any).AndroidClient;